import { render, staticRenderFns } from "./BusinessProducts.vue?vue&type=template&id=cab821e6&scoped=true&"
import script from "./BusinessProducts.vue?vue&type=script&lang=js&"
export * from "./BusinessProducts.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProducts.vue?vue&type=style&index=0&id=cab821e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab821e6",
  null
  
)

export default component.exports